import { escape, unescape } from 'html-escaper'
import { match } from 'ts-pattern'
import { v4 as uuidv4 } from 'uuid'

// Text with character entities were causing issues when later parsing the text as html. This strips
// the initial html but does not parse character entities into their final form.
export const stripHTML = (
  html: string,
  shouldEscape = false,
  resetEscapedEntities = false
): string => {
  const placeholderMap: Record<string, string> = {}

  const protectedEntitiesHtml = html.replaceAll(
    /&[\d#A-Za-z]+;/g,
    function (match) {
      const placeholder = `__ENTITY_PLACEHOLDER_${uuidv4().replaceAll(
        '-',
        ''
      )}__`
      placeholderMap[placeholder] = match
      return placeholder
    }
  )

  const strippedHtml = protectedEntitiesHtml.replaceAll(/<[^>]*>/g, '')

  const htmlWithRestoredEntities = strippedHtml
    .replaceAll(
      /__ENTITY_PLACEHOLDER_[\da-f]{32}__/g,
      (match) => placeholderMap[match] ?? match
    )
    .replaceAll('&lt;br /&gt;', '')

  return match({ resetEscapedEntities, shouldEscape })
    .with({ resetEscapedEntities: true, shouldEscape: true }, () =>
      escape(unescape(htmlWithRestoredEntities))
    )
    .with({ resetEscapedEntities: true, shouldEscape: false }, () =>
      unescape(htmlWithRestoredEntities)
    )
    .with({ resetEscapedEntities: false, shouldEscape: true }, () =>
      escape(htmlWithRestoredEntities)
    )
    .with(
      { resetEscapedEntities: false, shouldEscape: false },
      () => htmlWithRestoredEntities
    )
    .exhaustive()
}
